/**
 * EDITOR-ORIGIN.UTILS
 * Where the questionnaire editor was opened from (the project) : kept in the memory of the tab, so that a refresh of the
 * page (F5) does not lose the way back. The state of the navigation alone is empty after a refresh.
 * The editor forgets it when it is left, so a later visit from the list of the questionnaires never offers the project.
 */

const EDITOR_ORIGIN_KEY: string = "idt-editor-origin"

//Where the editor was opened from, null when it was opened from elsewhere
export function getEditorOrigin(): string | null {
  try {
    return sessionStorage.getItem(EDITOR_ORIGIN_KEY)
  } catch {
    return null
  }
}

export function rememberEditorOrigin(origin: string): void {
  try {
    sessionStorage.setItem(EDITOR_ORIGIN_KEY, origin)
  } catch {
    //The way back then only lasts until the page is refreshed
  }
}

export function forgetEditorOrigin(): void {
  try {
    sessionStorage.removeItem(EDITOR_ORIGIN_KEY)
  } catch {
    //Nothing to forget
  }
}

//Open the editor from the project : the state of the navigation and the memory of the tab say where to go back
export function openEditorFromProject(
  navigate: (to: string, options?: any) => void,
  path: string = "/template/editor"
): void {
  rememberEditorOrigin("/project/edit")
  navigate(path, { state: { from: "/project/edit" } })
}
